import { AdminUserPersonalInfoModel } from "./user_personal_info_model.js"
import { NoteModel } from "../../content/note_model.js";

import { RawUserModel } from "../user_model.js";
import SalutationEnum from "../../../enums/salutation.js";
import { InputLabelDisplayModeAbove } from "../../../base/inputs/constants.js";
import { UserPaymentMethodModel } from "../user_payment_method_model.js"
import { AddTypeAuto } from "../../../base/form/fields/nested_models_array_field.js.jsx"

class RawAdminUserModel extends RawUserModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "personalInfo",
        type: "nestedModel",
        model: AdminUserPersonalInfoModel,
        weight: 12,
      },
      {
        name: "note",
        type: "nestedModel",
        model: NoteModel,
        weight: 12,
      },
      {
        name: "password",
        displayName: this.fieldDisplayName("password"),
        type: "password",
        displayNamePosition: InputLabelDisplayModeAbove,
        weight: 12,
      },
      {
        name: "paymentMethods",
        type: "nestedModelsArray",
        fields: (parentField, item) => {
          return UserPaymentMethodModel.formFields({item: item, config: {weight: 12}});
        },
        weight: 12,
        itemWeight: 12,
        defaultWeight: 12,
        addType: AddTypeAuto,
        allowDragDrop: false
      }
    ]
  }

  i18nScope() {
    return "model.users.user";
  }

  displayValue(item) {
    if(!item) {
      return "";
    }
    const { personalInfo } = item;
    let names = []
    if(personalInfo) {
      if(personalInfo.salutation) {
        names.push(SalutationEnum.label(personalInfo.salutation))
      }
      if(personalInfo.salutation == "firma") {
        names.push(personalInfo.companyName)
      } else {
        if(personalInfo.firstName) {
          names.push(personalInfo.firstName);
        }
        if(personalInfo.lastName) {
          names.push(personalInfo.lastName);
        }
      }
    }
    if(names.length === 0)
      return item.email;
    return names.join(" ");
  }

}
const AdminUserModel = new RawAdminUserModel();

export { RawAdminUserModel, AdminUserModel }
